import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";
import { ItemVerbaDropDown } from "../../../domain/models/item_verba_dropdown";
import { MotivoAfastamentoDropDown } from "../../../domain/models/motivo_afastamento_dropdown";
import { CargoDropDown } from "../../../../../common/domain/models/cargo_dropdown";
import { MotivoDemissaoDropDown } from "../../../domain/models/motivo_demissao_dropdown";
import { TreinamentoDropDown } from "../../../domain/models/treinamento_dropdown";
import { FuncionarioDropDown } from "../../../../../common/domain/models/funcionario_dropdown";
import { HabilidadeDropDown } from "../../../domain/models/habilidade_dropdown";
import { EquipamentoDropDown } from "../../../domain/models/equipamento_dropdown";
import { FuncionarioAssinaturaDropDown } from "../../../domain/models/funcionario_assinatura_dropdown";

/**
 * useFilters
 */

type State = {
  centroCustoLista: CentroCustoDropDown[] | null,
  cargoLista: CargoDropDown[] | null,
  funcionarioLista: FuncionarioDropDown[] | null,
  treinamentoLista: TreinamentoDropDown[] | null,
  avaliacaoHabilidadesLista: HabilidadeDropDown[] | null,
  itensVerbaDropDownLista: ItemVerbaDropDown[] | null,
  equipamentoLista: EquipamentoDropDown[] | null,
  motivosAfastamentoLista: MotivoAfastamentoDropDown[] | null,
  motivosDemissaoDropDownLista: MotivoDemissaoDropDown[] | null,
  funcionarioAssinaturasDropDownLista: FuncionarioAssinaturaDropDown[] | null,
};

type Actions = {
  setCentroCustoLista: SetFunction<CentroCustoDropDown[]>,
  setCargoLista: SetFunction<CargoDropDown[]>,
  setFuncionarioLista: SetFunction<FuncionarioDropDown[]>,
  setTreinamentoLista: SetFunction<TreinamentoDropDown[]>,
  setHabilidadesLista: SetFunction<HabilidadeDropDown[]>,
  setEventosItensVerbaLista: SetFunction<ItemVerbaDropDown[]>,
  setEquipamentoLista: SetFunction<EquipamentoDropDown[]>,
  setAfastamentoMotivosAfastamento: SetFunction<MotivoAfastamentoDropDown[]>,
  setFuncionarioMotivosDemissaoDropDownLista: SetFunction<MotivoDemissaoDropDown[]>,
  setFuncionarioAssinaturasDropDownLista: SetFunction<FuncionarioAssinaturaDropDown[]>,
};

export const useFilters = create<State & Actions>((set) => ({
  centroCustoLista: null,
  cargoLista: null,
  funcionarioLista: null,
  treinamentoLista: null,
  equipamentoLista: null,
  avaliacaoHabilidadesLista: null,
  itensVerbaDropDownLista: null,
  motivosAfastamentoLista: null,
  motivosDemissaoDropDownLista: null,
  funcionarioAssinaturasDropDownLista: null,
  setCentroCustoLista: (vfn) => SetFunctionImpl(set, "centroCustoLista", vfn),
  setCargoLista: (vfn) => SetFunctionImpl(set, "cargoLista", vfn),
  setFuncionarioLista: (vfn) => SetFunctionImpl(set, "funcionarioLista", vfn),
  setTreinamentoLista: (vfn) => SetFunctionImpl(set, "treinamentoLista", vfn),
  setHabilidadesLista: (vfn) => SetFunctionImpl(set, "avaliacaoHabilidadesLista", vfn),
  setEventosItensVerbaLista: (vfn) => SetFunctionImpl(set, "itensVerbaDropDownLista", vfn),
  setEquipamentoLista: (vfn) => SetFunctionImpl(set, "equipamentoLista", vfn),
  setAfastamentoMotivosAfastamento: (vfn) => SetFunctionImpl(set, "motivosAfastamentoLista", vfn),
  setFuncionarioMotivosDemissaoDropDownLista: (vfn) => SetFunctionImpl(set, "motivosDemissaoDropDownLista", vfn),
  setFuncionarioAssinaturasDropDownLista: (vfn) => SetFunctionImpl(set, "funcionarioAssinaturasDropDownLista", vfn),
}));